import NavigationBar from "../../components/01_navigationBar/01_navigationBar";
import Footer from "../../components/02_footer/02_footer";

import img1 from "../../assets/final/Images/02_AboutPage/01_HeroSection_HeroImage.png"

import ico1 from "../../assets/final/Icons/02_AboutPage/01_Offerings.png"
import ico2 from "../../assets/final/Icons/02_AboutPage/02_Offerings.png"
import ico3 from "../../assets/final/Icons/02_AboutPage/03_Offerings.png"

import "./01_aboutPage.css"

export default function About() {
    return (
        <div>
            <NavigationBar />
            <div className="About-HeroSection">
                <h1>Hear Your Loved Ones Again with Advanced Hearing Aids</h1>
                <a href="/appointment">book an appointment</a>
            </div>
            <div className="About-StorySection">
                <p>Our Story</p>
                <div className="About-StorySection-Side">
                    <h1>Helping You Reconnect with the Sounds That Matter Most</h1>
                    <p>
                        Hearing aids are about more than better sound — they help you reconnect with conversations, relationships, and everyday confidence. With experienced audiologist support, professional hearing tests, and personalized hearing solutions, your hearing care is designed around your comfort, lifestyle, and budget. Whether you need advanced hearing aids, ongoing support, or hearing aid repair service, your quality of life always comes first.
                    </p>
                </div>
            </div>
            <div className="About-ValuesSection">
                <div className="About-ValuesSection-Card">
                    <img src={ico1} alt="" />
                    <h3>Expert Guidance</h3>
                    <p>
                        You deserve transparent recommendations and hearing solutions designed around your real needs.
                    </p>
                </div>
                <div className="About-ValuesSection-Card">
                    <img src={ico2} alt="" />
                    <h3>Personalized Hearing Care</h3>
                    <p>
                        Every hearing test and hearing aid recommendation is tailored to your lifestyle and comfort for all age groups
                    </p>
                </div>
                <div className="About-ValuesSection-Card">
                    <img src={ico3} alt="" />
                    <h3>Lifetine free expert support</h3>
                    <p>
                        Dependable hearing aid repair service and expert support help you enjoy better hearing for years to come.
                    </p>
                </div>
            </div>
            <div className="About-WhySection">
                <div className="About-WhySection-Side"> 
                    <p className="Quotes">
                        From hearing tests to personalized hearing aids, every step focuses on helping you communicate more comfortably and confidently.
                    </p>
                    <div className="About-WhySection-flex">
                        <div className="About-WhySection-card">
                            <p  className="About-WhySection-card-Met" >Expert Care</p>
                            <p>Hearing care tailored to every lifestyle</p>
                        </div>
                        <div className="About-WhySection-card">
                            <p  className="About-WhySection-card-Met" >25+ Years</p>
                            <p>Combined hearing healthcare expertise</p>
                        </div>
                        <div className="About-WhySection-card">
                            <p  className="About-WhySection-card-Met" >5,000+</p>
                            <p>Trusted hearing care interactions</p>
                        </div>
                        <div className="About-WhySection-card">
                            <p  className="About-WhySection-card-Met" >6 Locations</p>
                            <p>Serving Thane, Mumbai, and Goa</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}